import React from 'react'
import { twUserColors } from '../../../../shared-src/color'
import { getColorSet } from '@/theme/color'
import { Check } from 'lucide-react'

interface ColorOptionProps {
	color: string
	isSelected: boolean
	onSelect: (color: string) => void
}

function ColorOption(props: ColorOptionProps) {
	const colorSet = getColorSet({ senderColor: props.color })

	return (
		<button
			onClick={() => props.onSelect(props.color)}
			className="relative w-8 h-8 rounded-full border-2 transition-all 
				hover:scale-110 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
			style={{
				backgroundColor: colorSet.border,
				borderColor: colorSet.dark,
			}}
			aria-label={`Select ${props.color} color`}
		>
			{props.isSelected && (
				<div className="absolute inset-0 flex items-center justify-center">
					<Check className="w-4 h-4 text-gray-900" />
				</div>
			)}
		</button>
	)
}

interface ColorPickerProps {
	value: string
	onChange: (color: string) => void
	className?: string
}

export default function ColorPicker({ value, onChange, className = '' }: ColorPickerProps) {
	return (
		<div className={`flex flex-wrap gap-3 ${className}`}>
			{twUserColors.map((color) => (
				<ColorOption
					key={color}
					color={color}
					isSelected={value === color}
					onSelect={onChange}
				/>
			))}
		</div>
	)
}
